import axios from 'axios';
import { REACT_APP_TEAMCAMP_APIURL } from '../global/environment';
import { captureException } from './logService';
import { getAPIErrorReason } from '../helpers/common';
import { rootStore } from '../mobx/rootStore';

/**
 * @desc github connect
 * @param {*}
 */
export const githubAccountConnect = async (installationId: string) => {
  try {
    rootStore.settingStore.setLoading(true);
    const payload = { installationId };
    const response = await axios.post(`${REACT_APP_TEAMCAMP_APIURL}/github/bind`, payload);
    if (response) return true;
    return false;
  } catch (e) {
    const error = getAPIErrorReason(e) || 'Unable to add github account! please try again';
    captureException(error, 'settings');
    dispatchSettingError(error);
    return false;
  } finally {
    rootStore.settingStore.setLoading(false);
  }
};

/**
 * @desc Get account list
 * @param {*}
 */
export const getAccountsList = async () => {
  try {
    rootStore.settingStore.setLoading(true);
    const response = await axios.get(`${REACT_APP_TEAMCAMP_APIURL}/github/getAccountsList`);
    const { data } = response;
    if (data) {
      return data;
    }
    return false;
  } catch (e) {
    const error = getAPIErrorReason(e) || 'Unable to get account data! please try again';
    captureException(error);
    dispatchSettingError(error);
    return false;
  } finally {
    rootStore.settingStore.setLoading(false);
  }
};

/**
 * @desc delete github account
 * @param {*}
 */
export const deleteGithubAccount = async (accountId: number) => {
  try {
    rootStore.settingStore.setLoading(true);
    const response = await axios.delete(`${REACT_APP_TEAMCAMP_APIURL}/github/uninstall/${accountId}`);
    if (response) {
      return true;
    }
    return false;
  } catch (e) {
    const error = getAPIErrorReason(e) || 'Unable to delete github account ! please try again';
    captureException(error);
    dispatchSettingError(error);
    return false;
  } finally {
    rootStore.settingStore.setLoading(false);
  }
};

/**
 * @desc Get repository list
 * @param {*}
 */
export const getRepositoryList = async () => {
  try {
    rootStore.settingStore.setLoading(true);
    const response = await axios.get(`${REACT_APP_TEAMCAMP_APIURL}/github/getRepoList`);
    const { data } = response;
    if (data) {
      return data;
    }
    return false;
  } catch (e) {
    const error = getAPIErrorReason(e) || 'Unable to get repository data! please try again';
    captureException(error);
    dispatchSettingError(error);
    return false;
  } finally {
    rootStore.settingStore.setLoading(false);
  }
};

function dispatchSettingError(msg: string) {
  rootStore.alertNotificationStore.setErrorMessage(msg);
}
